/** Chunked upload (5 MB pieces, no proxy size limit): start → pieces with retry → finish. `onProgress(0..1)`. */
const putChunk = async (http, url, blob) => {
  for (let attempt = 0; ; attempt += 1) {
    try { return await http.put(url, blob, { headers: { "Content-Type": "application/octet-stream" } }); }
    catch (e) { if (attempt >= 2 || (e.response && e.response.status < 500)) throw e; await new Promise((r) => setTimeout(r, 800 * (attempt + 1))); }
  }
};

export async function chunkedUpload(http, { start, chunk, finish }, file, startBody, finishBody, onProgress) {
  const s = (await http.post(start, startBody)).data;
  for (let i = 0; i < s.chunks; i += 1) {
    await putChunk(http, chunk(s.id, i), file.slice(i * s.chunk_size, (i + 1) * s.chunk_size));
    onProgress?.((i + 1) / s.chunks);
  }
  return (await http.post(finish(s.id), finishBody)).data;
}
